import React, { useEffect, useState } from "react";
import t, { changeLanguage } from "../../../components/I18N/TranslateHelpers";
import { GetCurrentLocale } from "../../../components/Utils";
import {
  buttonForWishlist,
  buttonHtmlViewProduct,
  getFirstImageProduct,
  productExistsInWishlist,
} from "../../../components/UtilsForCart";
import { SpinnerOnTop } from "../../../components/SpinnerOnTop";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/RootReducer";
import ProductPrice from "../ProductPrice/ProductPrice";
import {canUserSeeProduct} from "../../../components/Catalogue/userCatalogUtils";

interface ComponentProps {
  userAccount: any;
  productItem: any;
  isRequestingAdd: boolean;
  productIdRequest: number;
  setProductIdRequest: any;
}

const ProductListView: React.FC<ComponentProps> = ({
                                                     userAccount,
                                                     productItem,
                                                     isRequestingAdd,
                                                     productIdRequest,
                                                     setProductIdRequest,
                                                   }: ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale);
  const dispatch = useDispatch();
  const [isInWishlist, setIsInWishlist] = useState(false);
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const userCatalogs = useSelector((state: RootState) => state.userRdc.userCatalog);

  useEffect(() => {
    if (userAccount && productItem) {
      if (productExistsInWishlist(productItem.id, userAccount.favouriteProducts)) {
        setIsInWishlist(true);
      }
    }
  }, [userAccount, productItem]);

  const canShow = canUserSeeProduct(productItem.id, userCatalogs);
  if (!canShow) return null;

  return (
    <article className="card card-product-list pl-0" key={productItem.id}>
      <div className="row g-0">
        <aside className="col-xl-3 col-md-4 align-items-center d-flex">
          <a
            href={`/${locale}${t("url_detail_product")}/${productItem.slug}?variant=${productItem.reference}`}
            className="img-wrap"
          >
            <img src={getFirstImageProduct(productItem, false)} alt={productItem.name} />
          </a>
        </aside>
        <div className="col-xl-6 col-md-5 col-sm-7">
          <div className="card-body">
            <a href={`/${locale}${t("url_detail_product")}/${productItem.slug}?variant=${productItem.reference}`}>
              <span className="title h5">{productItem.name}</span>
              <div className="price-wrap">
                <strong className="price">{productItem.brand.name}</strong>
                <span className="reference-product">{productItem.reference}</span>
              </div>
                <p className="title mb-2 py-3" dangerouslySetInnerHTML={{__html: productItem.description}}/>
            </a>
          </div>
        </div>
        <aside className="col-xl-3 col-md-3 col-sm-5">
          <div className="info-aside d-flex align-content-between flex-wrap">
            <ProductPrice productItem={productItem} mode="catalog" />
            <div className="mb-3">
              {buttonHtmlViewProduct(productItem.slug, locale, productItem.reference)}
            </div>
            {isRequestingAdd && productIdRequest === productItem.id ? (
              <div className="float-end d-flex col-md-12 pb-4">
                <SpinnerOnTop />
              </div>
            ) : isAuthenticated ? (
              buttonForWishlist(
                !isInWishlist,
                dispatch,
                productItem.id,
                setIsInWishlist,
                setProductIdRequest
              )
            ) : null}
          </div>
        </aside>
      </div>
    </article>
  );
};

export default ProductListView;
